import type { FinanceProductionRun } from "./types";

type FinanceQuantityRecord = Pick<FinanceProductionRun, "input" | "output">;

export function formatFinanceQuantity(
  record: FinanceQuantityRecord,
  side: "input" | "output",
): string {
  const value = record[side];
  const parts: string[] = [];

  if (value.kg > 0) {
    parts.push(`${value.kg.toLocaleString("en-CA")} kg`);
  }
  if (value.pieces > 0) {
    parts.push(`${value.pieces.toLocaleString("en-CA")} pieces`);
  }

  return parts.length > 0 ? parts.join(" · ") : "—";
}
